import { PermissionedRouteObject } from "@redotech/redo-merchant-app-common/routing/protected-routes";
import { developerChildRoutes } from "@redotech/redo-merchant-general-app/developer/routes";

export const developerRoutes: PermissionedRouteObject[] = [
  {
    path: "",
    handle: { breadcrumb: "Developer" },
    async lazy() {
      const { Page } = await import("../../page");
      return { element: <Page /> };
    },
    children: developerChildRoutes,
  },
];
